<template>
  <div ref="content">
    <template>
      <mdb-modal :show="modal" @close="closeModal()" size="xl" scrollable ref="modal">
        <mdb-modal-header>
          <mdb-modal-title>{{$t('Global.Angebotdetails')}}</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <mdb-tab tabs color="primary" justify>
            <mdb-tab-item :active="pillsActive==0" @click.native.prevent="pillsActive=0">{{$t('Angebot.Allgemein')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==1" @click.native.prevent="pillsActive=1">{{$t('Angebot.Kosten')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==2" @click.native.prevent="pillsActive=2" v-if="Angebot.ausstattungkueche || Angebot.ausstattungbad || Angebot.ausstattungsonstiges">{{$t('Angebot.Ausstattung')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==3" @click.native.prevent="pillsActive=3">{{$t('Angebot.Personenkreis')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==4" @click.native.prevent="pillsActive=4">{{$t('Angebot.Ansprechpartner')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==5" @click.native.prevent="pillsActive=5">{{$t('Angebot.Lage')}}</mdb-tab-item>
            <mdb-tab-item :active="pillsActive==6" @click.native.prevent="toggleLightbox" v-if="images.length > 0">{{$t('Angebot.Bilder')}}</mdb-tab-item>
          </mdb-tab>
          <mdb-tab-content>
            <mdb-tab-pane class="fade" key="show1" v-if="pillsActive==0">
              <ul class="list-group mb-5">
                <li class="list-group-item">{{$t('Angebot.Zimmerart')}}: <span v-for="art in this.arten" v-bind:key="art.value"><span v-if="art.value == Angebot.zimmerart">{{ art.text}}</span></span></li>
                <li class="list-group-item">{{$t('Angebot.Groeß')}}: {{ Angebot.zimmergroesse }}m²</li>
                <li class="list-group-item" v-if="Angebot.etage && Angebot.etage.length > 0 && (Angebot.stockwerk == '' ||Angebot.stockwerk == '0')">
                  {{$t('Angebot.Etage')}}:
                  <span v-bind:key="a.value" v-for="a in this.etage">
                          <span v-if="Angebot.etage && Angebot.etage.indexOf(a.value) >= 0">
                            {{ a.text}}
                          </span>
                      </span>
                </li>
                <li class="list-group-item" v-if="Angebot.stockwerk  && Angebot.stockwerk != '0'">
                  <span>{{Angebot.stockwerk}}. {{$t('Angebot.Stockwerk')}}</span>
                </li>
                <li class="list-group-item" v-if="Angebot.ort">{{$t('Angebot.Ort')}}: {{ Angebot.ort }}<span v-if="Angebot.plz && Angebot.ort">,</span> {{ Angebot.plz }}</li>
                <li class="list-group-item" v-if="Angebot.freiab && Angebot.freiab != '0000-00-00 00:00:00'">{{$t('Angebot.Freiab')}}: {{ Angebot.freiab  | date("DD.M.YYYY") }}</li>
                <li class="list-group-item" v-if="Angebot.freibis && Angebot.freibis != '0000-00-00 00:00:00'">{{$t('Angebot.Freibis')}}: {{ Angebot.freibis  | date("DD.M.YYYY") }}</li>
                <li class="list-group-item" v-if="Angebot.minimalemietdauer">{{$t('Angebot.Mindauer')}}: {{ Angebot.minimalemietdauer }}</li>
                <li class="list-group-item" v-if="Angebot.bemerkungen">{{$t('Angebot.Bemerkung')}}: {{ Angebot.bemerkungen}}</li>
              </ul>
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show2" v-if="pillsActive==1">
              <ul class="list-group mb-5">
                <li class="list-group-item">{{$t('Angebot.Miete')}}: {{ Angebot.miete }}</li>
                <li class="list-group-item">{{$t('Angebot.Nebenkosten')}}: {{ Angebot.nebenkosten}}</li>
                <li class="list-group-item" v-if="Angebot.nebenkostenart">{{$t('Angebot.Nebenkostenart')}}: <span v-for="art in this.nebenkostenArten" v-bind:key="art.value"><span v-if="art.value == Angebot.nebenkostenart">{{ art.text}}</span></span></li>
                <li class="list-group-item">{{$t('Angebot.Kaution')}}: {{ Angebot.kaution }}</li>
              </ul>
            </mdb-tab-pane>
            <mdb-tab-pane vertical class="fade" key="show3" v-if="pillsActive==2" >
              <mdb-row>
                <mdb-col col="3">
                  <mdb-tab pills color="primary" vertical>

                    <mdb-tab-item v-if="Angebot.ausstattungkueche" :active="verticalWithin==0" @click.native.prevent="verticalWithin=0">{{$t('Angebot.Kuche')}}</mdb-tab-item>
                    <mdb-tab-item v-if="Angebot.ausstattungbad" :active="verticalWithin==1" @click.native.prevent="verticalWithin=1 ">{{$t('Angebot.Bad')}}</mdb-tab-item>
                    <mdb-tab-item v-if="Angebot.ausstattungsonstiges" :active="verticalWithin==2" @click.native.prevent="verticalWithin=2">{{$t('Angebot.Sonstige')}}</mdb-tab-item>
                  </mdb-tab>
                </mdb-col>
                <mdb-col col="9">
                  <mdb-tab-content vertical>
                    <mdb-tab-pane class="fade" key="pills1" v-if="verticalWithin==0 && Angebot.ausstattungkueche">
                      <ul class="list-group mb-5">

                        <div v-bind:key="a.value" v-for="a in this.ausstattungKueche">

                          <li v-if="Angebot.ausstattungkueche && Angebot.ausstattungkueche.indexOf(a.value) >= 0" class="list-group-item">{{ a.text}}</li>
                        </div>
                      </ul>
                    </mdb-tab-pane>
                    <mdb-tab-pane class="fade" key="pills2" v-if="verticalWithin==1 && Angebot.ausstattungbad">
                      <ul class="list-group mb-5">
                        <div v-bind:key="a.value" v-for="a in this.ausstattungBad">

                          <li v-if="Angebot.ausstattungbad && Angebot.ausstattungbad.indexOf(a.value) >= 0" class="list-group-item">{{ a.text}}</li>
                        </div>


                      </ul>
                    </mdb-tab-pane>
                    <mdb-tab-pane class="fade" key="pills3" v-if="verticalWithin==2 && (Angebot.ausstattungsonstiges || Angebot.lift || Angebot.ausstattungsonstigesinternet || Angebot.ausstattungsonstigestelefon)">
                      <ul class="list-group mb-5">
                        <div v-bind:key="a.value" v-for="a in this.ausstattungSonstiges" v-if="Angebot.ausstattungsonstiges">
                          <li v-if="Angebot.ausstattungsonstiges && Angebot.ausstattungsonstiges.indexOf(a.value) >= 0" class="list-group-item">{{ a.text}}</li>
                        </div>
                        <li class="list-group-item" v-if="Angebot.lift">Lift: <span v-if="Angebot.lift == 0 ||Angebot.lift == '0'">Nein</span> <span v-else>Ja</span></li>
                        <li class="list-group-item" v-if="Angebot.ausstattungsonstigesinternet">Internetanschluss:
                          <template v-if="Angebot.ausstattungsonstigesinternet == 0 || Angebot.ausstattungsonstigesinternet == '0' || Angebot.ausstattungsonstigesinternet == 'nein' "><span>{{$t('Global.Nein')}}</span></template>
                          <template v-else-if="Angebot.ausstattungsonstigesinternet == 1 || Angebot.ausstattungsonstigesinternet == '1' || Angebot.ausstattungsonstigesinternet == 'ja' "><span>{{$t('Global.Ja')}}</span></template>
                          <template v-else-if="Angebot.ausstattungsonstigesinternet ==  'selbst' || Angebot.ausstattungsonstigesinternet == 2 || Angebot.ausstattungsonstigesinternet == '2' "><span>{{$t('Global.Selbst')}}</span></template>
                          </li>
                        <li class="list-group-item" v-if="Angebot.ausstattungsonstigestelefon">Telefonanschluss:
                          <template v-if="Angebot.ausstattungsonstigestelefon == 0 || Angebot.ausstattungsonstigestelefon == '0' || Angebot.ausstattungsonstigestelefon == 'nein' "><span>{{$t('Global.Nein')}}</span></template>
                          <template v-else-if="Angebot.ausstattungsonstigestelefon == 1 || Angebot.ausstattungsonstigestelefon == '1' || Angebot.ausstattungsonstigestelefon == 'ja' "><span>{{$t('Global.Ja')}}</span></template>
                          <template v-else-if="Angebot.ausstattungsonstigestelefon ==  'selbst' || Angebot.ausstattungsonstigestelefon == 2 || Angebot.ausstattungsonstigestelefon == '2' "><span>{{$t('Global.Selbst')}}</span></template>
                        </li>
                        <div v-bind:key="a.value" v-for="a in this.zusatz">
                          <li v-if=" Angebot.zimmerzusatzinformationen && Angebot.zimmerzusatzinformationen.indexOf(a.value) >= 0" class="list-group-item">{{ a.text}}</li>
                        </div>
                      </ul>
                    </mdb-tab-pane>
                  </mdb-tab-content>
                </mdb-col>
              </mdb-row>
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show4" v-if="pillsActive==3 ">
              <ul class="list-group mb-5">
                <li class="list-group-item" v-if="Angebot.mietergeschlecht">
                  {{$t('Angebot.Geschlecht')}}
                  <span v-if="Angebot.mietergeschlecht == 'm'">{{$t('Angebot.Geschlechts.Maennlich')}}</span>
                  <span v-else-if="Angebot.mietergeschlecht == 'w'">{{$t('Angebot.Geschlechts.Weiblich')}}</span>
                  <span v-else-if="Angebot.mietergeschlecht == 'e'">{{$t('Angebot.Geschlechts.Egal')}}</span>
                </li>
                <li class="list-group-item" v-if="Angebot.mieterraucher">{{$t('Angebot.Raucher')}} <span v-if="Angebot.mieterraucher == 1">{{$t('Global.Ja')}}</span><span v-else>{{$t('Global.Nein')}}</span></li>
                <li class="list-group-item" v-if="Angebot.mieterbevorzugt && Angebot.mieterbevorzugt.length > 0">
                  {{$t('Angebot.Bevorzugt')}}:
                  <span v-bind:key="a" v-for="(a, index) in Angebot.mieterbevorzugt">
                    <span v-if="index != Angebot.mieterbevorzugt.length -1">{{findByValue(bevorzugte, a)}}, </span>
                    <span v-else>{{findByValue(bevorzugte, a)}}</span>
                  </span>
                </li>

              </ul>

            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show5" v-if="pillsActive==4">
              <ul class="list-group mb-5">
                <li class="list-group-item" v-if="Angebot.name">{{$t('Angebot.Name')}}: {{ Angebot.name }}</li>
                <li class="list-group-item" v-if="Angebot.telefon">{{$t('Angebot.Tele')}}: {{ Angebot.telefon }}</li>
                <li class="list-group-item" v-if="Angebot.mobil">{{$t('Angebot.Handy')}}: {{ Angebot.mobil }}</li>
                <li class="list-group-item" v-if="Angebot.email" >{{$t('Angebot.Email')}}: {{ Angebot.email }}</li>
              </ul>
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show6" v-if="pillsActive==5">
              <ul class="list-group mb-5">
                <li class="list-group-item" v-if="Angebot.verkehrsanbindung && Angebot.verkehrsanbindung.length != 0">{{$t('Angebot.Erreichbar')}}:
                  <span v-bind:key="a.value" v-for="(a, index) in Angebot.verkehrsanbindung">

                     <span v-if="index != Angebot.verkehrsanbindung.length -1">{{findByValue(verkehrsanbindung, a)}}, </span>
                    <span v-else>{{findByValue(verkehrsanbindung, a)}}</span>

                  </span>
                </li>
                <li class="list-group-item" v-if="Angebot.entfernung">{{$t('Angebot.Entfernung')}}: {{ Angebot.entfernung }}</li>

              </ul>

            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show7" v-if="pillsActive==6">
              <ImageSlider :images="this.images"></ImageSlider>

            </mdb-tab-pane>
          </mdb-tab-content>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn color="primary" @click.native="closeModal()">{{$t('Global.Close')}}</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>
    </template>
  </div>
</template>

<script>

import ImageService from "@/services/ImageService.js";
//import settings from '@/components/Settings.json';
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane, mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs } from 'mdbvue';
import Angebot from "./Angebot";
import SettingService from '@/services/SettingsService';
import ImageSlider from "@/components/ImageSliderShow";
import { bus } from '@/main';
export default {
  name: "Modal",
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbTab,
      mdbTabItem,
      mdbTabContent,
      mdbTabPane,
      mdbContainer,
      mdbCol,
      mdbRow,
      mdbIcon,
      mdbTabs,
    ImageSlider
  },
  props: {
    modalActive: Boolean,
    isAufMerkliste: Boolean,
    listOrte: Array,
    lightbox: Boolean,
    settings: Object
  },

    data() {
      return {
        Angebot: Object,
        modal: false,
        images: [],
        pillsActive: 0,
          verticalWithin: 0,
          arten: [],
          nebenkostenArten: [],
          ausstattungBad: [],
          ausstattungKueche: [],
          ausstattungSonstiges: [],
          etage: [],
          zusatz: [],
          bevorzugte: [],
          verkehrsanbindung: [],
          merklistenView: false,


      };
    },
  methods:{
    closeModal() {
      this.modal = false;
      this.pills = 0;
      this.verticalWithin = 0;
    },
    selectOrt(key) {
      if(!key){return}
      key = key.replace(/ /g,'');
      this.listOrte.forEach(option => {
        if(option.value == key){
          option.selected = true;
          this.Angebot.ort = option.text;
        }
      });
    },
    setAngebotUp(){
      //Zimmerart
      //let value =  this.merkliste.indexOf(id);

    },
    getImages(id){
      ImageService.getImages(id).then(response => {
        let data = response.data;
        for(let i = 0; i < data.length; i++){
          data[i] = 'https://www.wohnungsdatenbank.uni-freiburg.de/storage/'+ data[i];
        }
        this.images = data;

      }).catch(error => {
                console.log("There was an error:", error.response);
      });
    },
    toggleLightbox(){
      bus.$emit('openLightbox', this.images);
      //this.$parent.toggleLightbox(this.images);
    },
    findByValue(source, val) {

      for (var i = 0; i < source.length; i++) {
        if (source[i].value === val) {
          return source[i].text;
        }
      }
      throw "Couldn't find object with id: " + val;
    },
  },
  mounted() {


      this.arten = this.settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
      this.nebenkostenArten = this.settings.Settings[1][this.$store.getters.lang][0].nebenkostenArten;
      this.ausstattungBad = this.settings.Settings[1][this.$store.getters.lang][0].ausstattungBad;
      this.ausstattungKueche = this.settings.Settings[1][this.$store.getters.lang][0].ausstattungKueche;
      this.ausstattungSonstiges = this.settings.Settings[1][this.$store.getters.lang][0].ausstattungSonstiges;
      this.etage = this.settings.Settings[1][this.$store.getters.lang][0].etage;
      this.zusatz = this.settings.Settings[1][this.$store.getters.lang][0].zusatz;
      this.verkehrsanbindung = this.settings.Settings[1][this.$store.getters.lang][0].anbindung;
      this.bevorzugte = this.settings.Settings[1][this.$store.getters.lang][0].Bevorzugte;


  },
  created (){
    bus.$on('openModal', (data) => {
      this.modal = true;
      this.Angebot = data;
      this.getImages(this.Angebot.persistence_object_identifier);

      this.selectOrt(this.Angebot.ort);
      this.merklistenView = this.isAufMerkliste;
      let mietergeschlecht = this.Angebot.mietergeschlecht;
      if(mietergeschlecht){
        if(mietergeschlecht == "Weiblich"){
          this.Angebot.mietergeschlecht = "w";
        } else if(mietergeschlecht == "Egal"){
          this.Angebot.mietergeschlecht = "e";
        } else if (mietergeschlecht == "Männlich"){
          this.Angebot.mietergeschlecht = "m";
        }
      }
    })
  },
  watch: {
      modalActive(newValue, oldValue) {
        this.modal = newValue;
      }
  }

  
};
</script>
<style scoped>
.tab-pane {
 height: 100% !important;
}
.v-enter-active {
  transition: .3s ease-in;
  opacity: 1;
  max-height: 500px;
}

.v-enter,
.v-leave-active {
  opacity: 0;
  max-height: 0;
}

.v-leave {
  opacity: 1;
  max-height: 500px;
}
</style>